import React from 'react';
import PropTypes from 'prop-types';

export default function CloseIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" {...rest}>
      <path
        fill={color}
        d="M7.15227137,6 L11.7613568,1.39091456 C12.0795477,1.07272362 12.0795477,0.556834155 11.7613568,0.238643209 C11.4431658,-0.0795477364 10.9272764,-0.0795477364 10.6090854,0.238643209 L6,4.84772863 L1.39091456,0.238643209 C1.07272362,-0.0795477364 0.556834155,-0.0795477364 0.238643209,0.238643209 C-0.0795477364,0.556834155 -0.0795477364,1.07272362 0.238643209,1.39091456 L4.84772863,6 L0.238643209,10.6090854 C-0.0795477364,10.9272764 -0.0795477364,11.4431658 0.238643209,11.7613568 C0.556834155,12.0795477 1.07272362,12.0795477 1.39091456,11.7613568 L6,7.15227137 L10.6090854,11.7613568 C10.9272764,12.0795477 11.4431658,12.0795477 11.7613568,11.7613568 C12.0795477,11.4431658 12.0795477,10.9272764 11.7613568,10.6090854 L7.15227137,6 Z"
      />
    </svg>
  );
}

CloseIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

CloseIcon.defaultProps = {
  size: 15,
  color: '#000',
};
